<p-dialog [(visible)]="show" (onHide)="wishlistService.hide()" [modal]="true" [resizable]="true">
  <ng-template pTemplate="header">
    <h4 i18n="@@addWishlist" class="uppercase">Ajouter à ma wishlist</h4>
  </ng-template>
  <form [formGroup]="form">
    @if (product) {
      <div>
        <div class="flex justify-content-between align-items-center border-bottom-1 border-cvbg-secondary">
          <h4 class="flex flex-column justify-content-center">
            <span>{{ product.nomVin }}</span>
            <span>{{ product.millesime }}</span>
          </h4>
          <div class="couleur {{product.couleur?.toLowerCase()}}"></div>
        </div>

        <div class="flex flex-column mt-6 mb-3 text-xs uppercase">
          <div class="flex justify-content-between align-items-center">
            <div class="flex flex-column uppercase">
              <p i18n="@@quantite" class="text-cvbg-secondary text-2xs">Quantité</p>
              <p i18n="@@eq75cl" class="text-cvbg-secondary text-3xs">/ éq 75cl</p>
            </div>
            <div class="w-8">
              <p-inputNumber [min]="1"
                             [max]="this.product.stockCommercial"
                             [showButtons]="true"
                             formControlName="quantity"
                             inputStyleClass="w-8 text-center"
                             decrementButtonClass="w-1rem mr-1 text-3xs"
                             incrementButtonClass="w-1rem ml-1 text-3xs"
                             decrementButtonIcon="fa-solid fa-minus"
                             incrementButtonIcon="fa-solid fa-plus"
                             buttonLayout="horizontal">
              </p-inputNumber>
            </div>
          </div>
        </div>
      </div>
    } @else {
      <div>
        @if (isTypeOfVin(form.controls['vin'].value)) {

          <div class="flex justify-content-between align-items-center border-bottom-1 border-cvbg-secondary">

            <h4 class="flex flex-column justify-content-center">
              {{ form.controls['vin'].value.nomVinR }}
            </h4>
            <div class="couleur {{form.controls['vin'].value.couleur?.toLowerCase()}}"></div>

          </div>

        }

        <div class="flex flex-column mt-6 mb-3 text-xs uppercase">

          <div class="flex justify-content-between align-items-center">
            <label i18n="@@vin" class="text-cvbg-secondary text-2xs uppercase" for="vin">Vin</label>
            <p-autoComplete
              id="vin"
              formControlName="vin"
              [suggestions]="suggestionsVins"
              (completeMethod)="rechercherVin($event)"
              optionLabel="nomVinR"
              appendTo="body"
              [ngClass]="{'error': form.controls['vin'].invalid && form.controls['vin'].touched}"
            />
          </div>

          <div class="flex justify-content-between align-items-center my-2 min-h-40">
            <label i18n="@@millesime" class="text-cvbg-secondary text-2xs uppercase" for="millesime">Millesime</label>

            @if(wishlistService.type() !== TypeCampagne.Primeurs){
              <input
                id="millesime"
                pInputText
                formControlName="millesime"
              />
            }
            @else {
              <span>
                {{yearPrimeurs}}
              </span>
            }

          </div>

          <div class="flex justify-content-between align-items-center">
            <div class="flex flex-column uppercase">
              <p i18n="@@quantite" class="text-cvbg-secondary text-2xs">Quantité</p>
              <p i18n="@@eq75cl" class="text-cvbg-secondary text-3xs">/ éq 75cl</p>
            </div>
            <div>
              <p-inputNumber
                [min]="1"
                [showButtons]="true"
                formControlName="quantity"
                inputStyleClass="w-8 text-center"
                decrementButtonClass="w-1rem mr-1 text-3xs"
                incrementButtonClass="w-1rem ml-1 text-3xs"
                decrementButtonIcon="fa-solid fa-minus"
                incrementButtonIcon="fa-solid fa-plus"
                buttonLayout="horizontal"
                [ngClass]="{'error': form.controls['quantity'].invalid && form.controls['quantity'].touched}"
              >
              </p-inputNumber>
            </div>
          </div>
        </div>
      </div>
    }
  </form>
  <ng-template pTemplate="footer">
    <p-button i18n-label="@@ajouter"
              (onClick)="addToWishlist()"
              type="submit"
              styleClass="w-full p-3 text-sm"
              label="ajouter"
              iconPos="right"
              icon="fa-regular fa-heart">
    </p-button>
  </ng-template>
</p-dialog>

